import { Controller } from "stimulus";
import Cookie from "../../entrypoints/src/lib/cookie";

// Pins the app's left nav drawer open when the Conversas screen loads, so the product
// sidebar (views/channels/saved filters) stays available beside the content — mirrors the
// manager-tickets auto-pin behaviour.
export default class extends Controller {
  connect() {
    this.pin();
  }

  pin() {
    const pinButton = document.querySelector('[data-controller="menu--pin-button"]');
    const sidebar = document.querySelector('#logo-sidebar');
    const gridBody = document.querySelector('#grid-body');

    if (!sidebar) return;

    Cookie.setCookie('menu_pin', 'pin');
    if (pinButton) pinButton.dataset.state = 'pin';
    sidebar.setAttribute('aria-pin', 'pin');
    sidebar.setAttribute('aria-menu', 'opened');

    if (gridBody) {
      gridBody.classList.remove('md:ml-14');
      gridBody.classList.add('md:ml-[22rem]');
    }
  }
}
